module.exports = __webpack_public_path__ + "static/media/paceWebsite.39b0748b.png";